import { render, staticRenderFns } from "./SidebarTwo.vue?vue&type=template&id=12d53f23&scoped=true&"
import script from "./SidebarTwo.vue?vue&type=script&lang=js&"
export * from "./SidebarTwo.vue?vue&type=script&lang=js&"
import style0 from "./SidebarTwo.vue?vue&type=style&index=0&id=12d53f23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d53f23",
  null
  
)

export default component.exports